module.exports = __webpack_public_path__ + "static/media/imgs.e43f0a77.png";